import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import About from "./About";
// import Contact from "./Contact";
import LogoDesgin from "./LogoDesgin";
import "./home.css";
import Services from "./Services";

const services = ["Web Design", "Logo Design", "Invitation Card Design"];

const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % services.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="home-wrapper">
        <div className="polygon-grid"></div>

        <div className="left-section">
          <h1 className="main-title">
            Welcome to <span className="creovate">Creovate</span>
          </h1>
          <div className="animated-text">
            <AnimatePresence mode="wait">
              <motion.span
                key={services[currentIndex]}
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 50 }}
                transition={{ duration: 0.6 }}
                className="service-text"
              >
                {services[currentIndex]}
              </motion.span>
            </AnimatePresence>
          </div>
        </div>

        <div className="right-section">
          <div className="editor-card">
            <div className="editor-header">
              <span className="control red"></span>
              <span className="control yellow"></span>
              <span className="control green"></span>
            </div>
            <div className="editor-body">
              <div className="gradient-bar">
                <div className="gradient-left"></div>
                <div className="gradient-right"></div>
              </div>
              <div className="inner-content">
                <div className="editor-code">
                  <p><span className="keyword">const</span> <span className="variable">company</span> = {"{"}</p>
                  <p className="indent"><span className="property">name:</span> <span className="string">'Creovate'</span>,</p>
                  <p className="indent"><span className="property">established:</span> <span className="number">2024</span>,</p>
                  <p className="indent"><span className="property">services:</span> [<span className="string">'Website Design'</span>, <span className="string">'Logo Design'</span>, <span className="string">'Card Design'</span>],</p>
                  <p className="indent"><span className="property">motto:</span> <span className="string">'We Create, You Celebrate'</span>,</p>
                  <p className="indent"><span className="property">innovationDriven:</span> <span className="boolean">true</span>,</p>
                  <p className="indent"><span className="property">hireable:</span> <span className="function">function</span>() {"{"}</p>
                  <p className="double-indent"><span className="keyword">return</span> (this.innovationDriven && this.services.length &gt;= 3);</p>
                  <p className="indent">{"}"},</p>
                  <p>{"}"};</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Sections */}
      <section id="services" className="section-container">
        <Services />
      </section>
      <section id="about" className="section-container">
        <About />
      </section>
      
      {/* <section id="contact" className="section-container">
        <Contact />
      </section> */}
    </>
  );
};

export default Home;
